module.exports = __webpack_public_path__ + "img/ic_receipt.45e309b0.png";